<template>
  <div style="width:100%;float:left;">
      <!-- {{parseXml(data)}} -->
      <!-- <textarea v-model="data"></textarea> -->
    <!-- <div class="col-sm-12 col-md-4 float-left">
      <img id="img" style="width:100%;" />
    </div> -->
    <div style="width:100%;float:left;" class="float-left">
      <table class="table" style="width:100%;float:left;" v-if="stop_records && thread_records">
        <thead>
          <tr>
            <!-- <th>Stop#</th>
            <th>Color#</th> -->
            <th>#Stitches</th>
            <th>Color</th>
            <!-- <th>Thread Name</th> -->
            <th>Code</th>
            <!-- <th></th> -->
          </tr>
        </thead>
        <tbody>
          <tr v-for="(val, index) in stop_records">
            <!-- <td>{{index + 1}}</td>
            <td>{{index + 1}}</td> -->
            <td>{{stop_records[index].num_stitches}}</td>
            <td>
              <div @click="showColor(index)" style="cursor:pointer;width:50px;height:30px;border: 1px solid black;" :style="configureBackground(index)"></div>
            </td>
            <!-- <td>{{thread_records[index].color_selected ? thread_records[index].color_selected.brand : thread_records[index].brand}}</td> -->
            <td>{{thread_records[index].color_selected ? thread_records[index].color : thread_records[index].code}}</td>
            <!-- <td>
              <v-select
                :options="colors"
                label="description"
                v-model="thread_records[index].color_selected"
                @input="colorChanged(index)"
                ></v-select>
            </td> -->
          </tr>
        </tbody>
      </table>
      <div style="width:100%;float:left;text-align:center;">
        <CButton size="sm" color="success" @click="update()">Update </CButton>
      </div>
    </div>

    <CModal title="Change Color" :show.sync="colorModal">
      <CBody v-if="colorIndex !== null">
        <table class="table">
          <tbody>
            <tr v-for="val in colors">
              <td>
                <div style="width:50px;height:30px;border:1px solid black;" :style="'background-color:rgb(' + val.color + ');'"></div>
              </td>
              <td>
                {{val.description}}
              </td>
              <td>
                <CButton size="sm" color="secondary" @click="thread_records[colorIndex].color_selected = val, colorModal = false, colorIndex = null">Select</CButton>
              </td>
            </tr>
          </tbody>
        </table>
      </CBody>
    </CModal>

  </div>
</template>
<script>
var methods = {}

methods.showColor = function (index) {
  this.colorIndex = index
  this.colorModal = true
}

methods.update = function () {
  var threads = this.getNew(this.data)
  // var xmlText = new XMLSerializer().serializeToString(doc);
  // console.log(xmlText)
  const postData = {
    // xml: xmlText
    threads: threads
  }
  console.log(postData)
  axios.post(this.$apiAdress + '/api/updateWilcom?token=' + localStorage.getItem('api_token'), postData).then(response => {
    console.log(response)
    this.setImage(response.data)
  })
}

methods.colorChanged = function (index) {
  console.log(this.thread_records[index])

}

methods.configureBackground = function (index) {
  if (this.thread_records[index].color_selected) {
    return 'background-color:rgb(' + this.thread_records[index].color_selected.color + ');'
  } else {
    var color = this.configureRgb(this.thread_records[index].color)
    return 'background-color:rgb(' + color + ');'
    // return ''
  }
}

methods.configureRgb = function (color) {
  console.log(color)
  var r = parseInt(color & 0x000000ff)
  var g = parseInt((color >> 8) & 0x000000ff)
  var b = parseInt((color >> 16) & 0x000000ff)
  var str = r + ',' + g + ',' + b
  console.log(str)
  return str
}

methods.getNew = function (data) {
  var parser = new DOMParser();
  var xmlDoc = parser.parseFromString(data,"text/xml");
  this.image = xmlDoc.getElementsByTagName("file")[0].getAttribute('filecontents')
  console.log(xmlDoc.getElementsByTagName("xml")[0])
  var threads = xmlDoc.getElementsByTagName("threads")[0]
  var stops = xmlDoc.getElementsByTagName("stop_sequence")[0]
  console.log(threads)
  console.log(stops)
  var stop_records = []
  var thread_records = []
  var i = 0
  var j = 0
  var that = this
  stops.childNodes.forEach(function (val) {
      if (val.localName === 'stop_record') {
          val.attributes[0].nodeValue = that.stop_records[i].color_idx
          val.attributes[1].nodeValue = that.stop_records[i].num_stitches
          i++
      }
  })
  var thread = []
  threads.childNodes.forEach(function (val) {
      if (val.localName === 'thread') {
          // val.attributes[0].nodeValue = that.thread_records[j].color
          // val.attributes[1].nodeValue = that.thread_records[j].code
          // val.attributes[2].nodeValue = that.thread_records[j].brand
          if (!that.thread_records[j].color_selected) {
            // val.attributes[0].nodeValue = "0"
            // val.attributes[1].nodeValue = "BLACK"
            // val.attributes[2].nodeValue = that.thread_records[j].brand
            var obj = {}
            obj.color = that.thread_records[j].color
            obj.code = that.thread_records[j].code
            obj.brand = that.thread_records[j].brand
            obj.description = that.thread_records[j].description
          } else {
            // val.attributes[0].nodeValue = "0"
            // val.attributes[1].nodeValue = "BLACK"
            // val.attributes[2].nodeValue = that.thread_records[j].brand
            var obj = {}
            var colArr = that.thread_records[j].color_selected.color.split(',')
            console.log(colArr)
            obj.color = parseInt(colArr[0]) + (parseInt(colArr[1]) << 8) + (parseInt(colArr[2]) << 16)
            console.log(obj.color)
            obj.code = that.thread_records[j].color_selected.code
            obj.brand = that.thread_records[j].color_selected.brand
            obj.description = that.thread_records[j].color_selected.description
          }
          
          thread.push(obj)
          j++
      }
  })
  return thread
}

methods.parseXml = function (xml) {
   //  var dom = null;
   // if (window.DOMParser) {
   //    try { 
   //       dom = (new DOMParser()).parseFromString(xml, "text/xml"); 
   //    } 
   //    catch (e) { dom = null; }
   // }
   // else if (window.ActiveXObject) {
   //    try {
   //       dom = new ActiveXObject('Microsoft.XMLDOM');
   //       dom.async = false;
   //       if (!dom.loadXML(xml)) // parse error ..

   //          window.alert(dom.parseError.reason + dom.parseError.srcText);
   //    } 
   //    catch (e) { dom = null; }
   // }
   // else
   //    alert("cannot parse xml string!");
   // return dom;
}

methods.setImage = function (data) {
  var parser = new DOMParser();
  var xmlDoc = parser.parseFromString(data,"text/xml");
  this.image = xmlDoc.getElementsByTagName("file")[0].getAttribute('filecontents')
  console.log(xmlDoc.getElementsByTagName("xml")[0])
  var threads = xmlDoc.getElementsByTagName("threads")[0]
  var stops = xmlDoc.getElementsByTagName("stop_sequence")[0]
  console.log(threads)
  console.log(stops)
  var stop_records = []
  var thread_records = []
  stops.childNodes.forEach(function (val) {
      if (val.localName === 'stop_record') {
          var obj = {}
          obj.color_idx = val.attributes[0].nodeValue
          obj.num_stitches = val.attributes[1].nodeValue
          stop_records.push(obj)
      }
  })
  threads.childNodes.forEach(function (val) {
      if (val.localName === 'thread') {
          var obj = {}
          obj.color = val.attributes[0].nodeValue
          obj.code = val.attributes[1].nodeValue
          obj.brand = val.attributes[2].nodeValue
          obj.description = val.attributes[3].nodeValue
          obj.color_selected = ''
          thread_records.push(obj)
      }
  })
  console.log(stop_records)
  console.log(thread_records)
  this.stop_records = stop_records
  this.thread_records = thread_records
  this.xmlDoc = xmlDoc
  var that = this
  setTimeout(function () {
      // document.getElementById("img").src = 'data:image/png;base64, ' + that.image;
      that.$emit('loaded', that.image)

  }, 1000);
}

export default {
    // ===Component name
    name: "XmlDisplay",
    // ===Props passed to component
    props: ['data'],
    // ===Components used by this component
    components: {

    },
    // ====component Data properties
    data(){
        return{
          stop_records: null,
          thread_records: null,
          image: null,
          colorModal: false,
          colorIndex: null,
          xmlDoc: null,
          colors: [
            { code: '0015',
              brand:'Isacord 30',
              description: 'White',
              idk: 'B',
              color: '255,255,255'
            },
            { code: '0010',
              brand:'Isacord 30',
              description: 'Parchment',
              idk: 'B',
              color: '255,255,250'
            },
            { code: '0600',
              brand:'Isacord 30',
              description: 'Yellow',
              idk: 'B',
              color: '255,255,0'
            },
            { code: '0702',
              brand:'Isacord 30',
              description: 'Mid Gold',
              idk: 'B',
              color: '255,230,75'
            },
            { code: '0704',
              brand:'Isacord 30',
              description: 'Darker Gold',
              idk: 'B',
              color: '245,240,102'
            },
            { code: '0800',
              brand:'Isacord 30',
              description: 'Orange Gold',
              idk: 'B',
              color: '255,245,0'
            },
            { code: '1355',
              brand:'Isacord 30',
              description: 'Dark Brown',
              idk: 'B',
              color: '153,102,51'
            },
            { code: '1346',
              brand:'Isacord 30',
              description: 'Night Brown',
              idk: 'B',
              color: '135,90,45'
            },
            { code: '1304',
              brand:'Isacord 30',
              description: 'Orange',
              idk: 'B',
              color: '255,125,0'
            },
            { code: '1703',
              brand:'Isacord 30',
              description: 'Red',
              idk: 'B',
              color: '255,0,0'
            },
            { code: '1902',
              brand:'Isacord 30',
              description: 'Dark Red',
              idk: 'B',
              color: '204,0,0'
            },
            { code: '1913',
              brand:'Isacord 30',
              description: 'Brown Fox',
              idk: 'B',
              color: '204,51,0'
            },
            { code: '1912',
              brand:'Isacord 30',
              description: 'Plum',
              idk: 'B',
              color: '175,0,75'
            },
            { code: '2123',
              brand:'Isacord 30',
              description: 'Dark Plum',
              idk: 'B',
              color: '135,0,51'
            },
            { code: '2241',
              brand:'Isacord 30',
              description: 'Plum Pink',
              idk: 'B',
              color: '204,140,150'
            },
            { code: '2250',
              brand:'Isacord 30',
              description: 'Mauve Pink',
              idk: 'B',
              color: '255,204,215'
            },
            { code: '3543' ,
              brand:'Isacord 30',
              description: 'Marine Blue',
              idk: 'B',
              color: '51,0,204'
            },
            { code: '3355',
              brand:'Isacord 30',
              description: 'Navy',
              idk: 'B',
              color: '0,0,102'
            },
            { code: '3820',
              brand:'Isacord 30',
              description: 'Medium Blue',
              idk: 'B',
              color: '150,190,230'
            },
            { code: '5422',
              brand:'Isacord 30',
              description: 'Teal Green',
              idk: 'B',
              color: '60,175,120'
            },
            { code: '5326',
              brand:'Isacord 30',
              description: 'Dark Leaf Green',
              idk: 'B',
              color: '0,115,80'
            },
            { code: '0761',
              brand:'Isacord 30',
              description: 'Light Grey Brown',
              idk: 'B',
              color: '245,235,204'
            },
            { code: '1876',
              brand:'Isacord 30',
              description: 'Brownish Green',
              idk: 'B',
              color: '125,90,50'
            },
            { code: '0851',
              brand:'Isacord 30',
              description: 'Gold',
              idk: 'B',
              color: '240,204,145'
            },
            { code: '0124',
              brand:'Isacord 30',
              description: 'Light Grey Brown',
              idk: 'B',
              color: '204,204,185'
            },
            { code: '0111',
              brand:'Isacord 30',
              description: 'Dark Grey',
              idk: 'B',
              color: '127,127,127'
            },
            { code: '0142',
              brand:'Isacord 30',
              description: 'Silver Grey',
              idk: 'B',
              color: '178,178,178'
            },
            { code: '0020',
              brand:'Isacord 30',
              description: 'Black',
              idk: 'B',
              color: '0,0,0'
            },
          ]
        }
    },
    watch: {
      'data': function (newVal, oldVal) {
        this.setImage(this.data)
      }
    },
    // ===Code to be executed when Component is mounted
    mounted() {
        console.log(this.data)
        console.log('hi')
        this.setImage(this.data)
    },
    // ===Computed properties for the component
    computed: {},
    // ===Component methods
    methods: methods
}
</script>
<!-- styles -->
<!-- adding scoped attribute will apply the css to this component only -->
<style scoped></style>
